module.exports = __webpack_public_path__ + "static/img/logo.a4ede5d9.png";